module.exports = __webpack_public_path__ + "img/40exp.1925cbdf.jpg";